module.exports = __webpack_public_path__ + "static/media/smart_wifi_plug_2x.b58bfaaa.png";